import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AIGenerationType, getGenerationType } from '../../utils/ai-response-types.interface';
import { AiGenerateDataModelCanvasComponent } from './ai-generate-data-model-canvas/ai-generate-data-model-canvas.component';
import { AiEntityVisualizationCanvasComponent } from './ai-entity-visualization-canvas/ai-entity-visualization-canvas.component';

@Component({
  selector: 'rappider-ai-canvas-renderer',
  standalone: true,
  imports: [
    CommonModule,
    AiEntityVisualizationCanvasComponent,
    AiGenerateDataModelCanvasComponent
  ],
  templateUrl: './ai-canvas-renderer.component.html',
  styleUrls: ['./ai-canvas-renderer.component.scss']
})
export class AiCanvasRendererComponent {
  @Input() canvasKey: string | undefined;
  @Input() selectedProjectModelId: string | undefined;
  @Input() componentDefinitionId: string | undefined;

  readonly AIGenerationType = AIGenerationType;

  /**
   * Get canvas type from canvasKey
   */
  get canvasType(): AIGenerationType | null {
    return this.canvasKey ? getGenerationType(this.canvasKey) : null;
  }

}
